// ── Theme — JF Finance ───────────────────────────────────────────────────────
const THEMES = {
  dark: {
    "--c-bg":      "#0B1120",
    "--c-card":    "#111827",
    "--c-surface": "#1A2236",
    "--c-border":  "#1E2D45",
    "--c-text":    "#F0F4FF",
    "--c-muted":   "#7C93B5",
    "--c-gold":    "#E8A21C",
    "--c-green":   "#22C55E",
    "--c-red":     "#F04444",
    "--c-blue":    "#4D9EF7",
    "--c-orange":  "#F97316",
    "--c-bg-head": "#0B1120",
  },
  light: {
    "--c-bg":      "#EDF0F5",
    "--c-card":    "#F7F9FC",
    "--c-surface": "#E8ECF2",
    "--c-border":  "#C8D2DF",
    "--c-text":    "#14202E",
    "--c-muted":   "#5A6E84",
    "--c-gold":    "#C48A00",
    "--c-green":   "#16A34A",
    "--c-red":     "#DC2626",
    "--c-blue":    "#2563EB",
    "--c-orange":  "#EA6C00",
    "--c-bg-head": "#14202E",
  },
};

export const T = {
  get bg()      { return getComputedStyle(document.documentElement).getPropertyValue("--c-bg").trim(); },
  get card()    { return getComputedStyle(document.documentElement).getPropertyValue("--c-card").trim(); },
  get surface() { return getComputedStyle(document.documentElement).getPropertyValue("--c-surface").trim(); },
  get border()  { return getComputedStyle(document.documentElement).getPropertyValue("--c-border").trim(); },
  get text()    { return getComputedStyle(document.documentElement).getPropertyValue("--c-text").trim(); },
  get muted()   { return getComputedStyle(document.documentElement).getPropertyValue("--c-muted").trim(); },
  get gold()    { return getComputedStyle(document.documentElement).getPropertyValue("--c-gold").trim(); },
  get green()   { return getComputedStyle(document.documentElement).getPropertyValue("--c-green").trim(); },
  get red()     { return getComputedStyle(document.documentElement).getPropertyValue("--c-red").trim(); },
  get blue()    { return getComputedStyle(document.documentElement).getPropertyValue("--c-blue").trim(); },
  get orange()  { return getComputedStyle(document.documentElement).getPropertyValue("--c-orange").trim(); },
  get bgHead()  { return getComputedStyle(document.documentElement).getPropertyValue("--c-bg-head").trim(); },
};

export function applyTheme(mode) {
  const t = THEMES[mode] || THEMES.dark;
  Object.entries(t).forEach(([k, v]) => document.documentElement.style.setProperty(k, v));
  try { localStorage.setItem("jf_theme", mode); } catch {}
}

// Apply on load
;(() => {
  try {
    const m = localStorage.getItem("jf_theme") || "dark";
    Object.entries(THEMES[m] || THEMES.dark).forEach(([k,v]) => document.documentElement.style.setProperty(k,v));
  } catch {}
})();
